import { Component, effect, inject, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { CountryNamePipe } from '@shared/pipes';
import { EntityListComponent, UnavailableComponent } from '@shared/components';
import { SchoolFacade } from '@app/store/school';
import { UsersImporterFacade } from '@app/store/users-importer';
import { DeleteButtonComponent } from './delete-button/delete-button.component';
import { ImportLearnersComponent } from './import-learners/import-learners.component';

@Component({
    selector: 'app-school-view-modal',
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.css'],
    imports: [TranslateModule, ButtonModule, CountryNamePipe, EntityListComponent, DeleteButtonComponent, ImportLearnersComponent, UnavailableComponent],
})
export class ViewComponent implements OnDestroy {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    private readonly schoolFacade = inject(SchoolFacade);
    private readonly usersImporterFacade = inject(UsersImporterFacade);

    readonly school = this.schoolFacade.school;
    readonly loading = this.schoolFacade.loading;
    readonly error = this.schoolFacade.error;
    readonly saving = this.schoolFacade.saving;

    constructor() {
        const id = this.route.parent?.snapshot.params['id'];
        if (id) {
            this.schoolFacade.getSchool(id);
        }

        effect(() => {
            if (this.schoolFacade.saved()) {
                this.close({ replaceUrl: !this.schoolFacade.school() });
            }
        });
    }

    ngOnDestroy(): void {
        this.schoolFacade.clear();
        this.usersImporterFacade.clear();
    }

    onEdit(): void {
        const school = this.school();
        if (school) {
            this.router.navigate([{ outlets: { modal: ['schools', 'edit', school.id] } }]);
        }
    }

    close({ replaceUrl } = { replaceUrl: false }): void {
        this.router.navigate([{ outlets: { modal: null } }], { replaceUrl });
    }
}
